import { formatSecondsToMinutesSeconds } from "../../../helpers/date/date-helper";

export const GeneralTimeline = ({ phases, phasesColor, phasesText, defaultDuration=60, bgColor='bg-perception-black-700', tickColor='light' }) => {
  const startDate = phases.length > 0 ? phases[0].start_date : null;
  const liveDuration = phases.length > 0 ? phases[phases.length - 1].end_date - phases[0].start_date : 0;
  const displayDuration = Math.max(defaultDuration, liveDuration);

  const ticksNumber = Math.min(Math.ceil(displayDuration / 30), 10);
  const tickInterval = displayDuration / ticksNumber;

  const tickBorderColorClass = tickColor === 'light' ? 'border-white' : 'border-gray-600';
  const tickTextColorClass = tickColor === 'light' ? 'text-white' : 'text-gray-600';

  return (
    <div className="h-full flex max-h-64">
      <div className="h-full w-full flex flex-col gap-1">
        {/* Live timeline */}
        <div className={`flex-1 relative ${bgColor} rounded-md`}>
          {
            phases.filter((phase) => phase.type > 0).map((phase, index) => {
              if (phase.type <= 0) return null;

              const barPosition = (phase.start_date - startDate) / displayDuration * 100;
              const barWidth = (phase.end_date - phase.start_date) / displayDuration * 100;
              const barColor = phasesColor[phase.type];
              const barText = phasesText[phase.type];

              return (
                <div className="h-full absolute py-1 z-5" style={{ left: `${barPosition}%`, width: `${barWidth}%` }} key={index}>
                  <div className={`h-full ${barColor} truncate select-none rounded-md flex items-center p-2 text-sm text-white`}>
                    {barText}
                  </div>
                </div>
              );
            })
          }
        </div>

        {/* Ticks */}
        <div className="relative flex-shrink-0">
          {Array.from({ length: ticksNumber + 1 }).map((_, tickIndex) => {
            const tickTime = tickIndex * tickInterval;
            const tickPosition = (tickTime / displayDuration) * 100;
            const halfTickPosition = (tickTime + tickInterval / 2) / displayDuration * 100;

            return (
              <div key={tickIndex} className='inline-block select-none' style={{ width: `${100 / ticksNumber}%` }}>
                {/* TICK */}
                <div className={`absolute border-l ${tickBorderColorClass}`} style={{ height: "10px", left: `${tickPosition}%`, top: "5px" }}/>

                {/* HALF TICK */}
                {halfTickPosition <= 100 && (
                  <div className={`absolute border-l ${tickBorderColorClass}`} style={{height: "5px", left: `${halfTickPosition}%`, top: "5px"}}/>
                )}

                {/* TIME */}
                <div className={`text-xs ${tickTextColorClass}`} style={{ position: 'absolute', left: `${tickPosition}%`, top: '20px', transform: 'translateX(-50%)' }}>
                  {formatSecondsToMinutesSeconds(tickTime)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};